export default {
    data() {
        return {
            orderDetails: {},
            dialogVisible: true,
            // 课程包数组
            categoryList: []
        }
    },
    methods: {
        orderDetailsData: function () {
            let id=this.$route.query.order_id;
            this.$post('orders/get',{token:this.$store.state.id,id:id}).then(res=>{
                res.data.result.commodityInfo=[];
                this.orderDetails=res.data.result;
            }).then(()=>{
                this.$post('purchased/search',{token:this.$store.state.id,order_id:id,offset:0,length:999}).then(res=>{
                    this.orderDetails.commodityInfo=res.data.result.data;
                })
            })
           
        },
        //判断支付方式
        paytype(){
            if(this.orderDetails.pay_type == 1){
                return '微信支付';
            }
            else if(this.orderDetails.pay_type == 2){
                return '支付宝支付'
            }
            else{
                return '余额支付'
            }
        },
        homePage: function () {
            this.$router.push({
                path: '/'
            })
        },
        goMyOrder: function () {
            this.$router.push({
                path: '/myorder'
            })
        },
    },


    created: function () {
        this.orderDetailsData();
    },
    mounted: function () {
        document.title='订单详情';

        // 获取从上一个页面传过来的数据
        this.categoryList = JSON.parse(this.$route.query.categoryList);
        console.log(this.categoryList)
    }
}

